import React from 'react';
import { IconButton } from 'react-native-paper';
import { useGptConversationContext } from '../../../GptConversation/context';
import createStyles from '../style';

export default function FileButton() {
  const { props, aiResponding, setFileSelected, imageCompress } =
    useGptConversationContext();
  const { selectFile } = props?.fileActions || {};
  const styles = createStyles(props);

  const chooseFile = async () => {
    if (selectFile) {
      // MIK-5038: off by default, so the attachment keeps going up untouched.
      const file = await selectFile({ imageOnly: false, imageCompress });
      if (file) {
        setFileSelected(file);
        return;
      }
      console.error('===error when select file', 'file is empty');
    }
    alert('Something went wrong!');
  };

  return (
    <IconButton
      onPress={chooseFile}
      icon={'attachment'}
      disabled={aiResponding}
      style={[styles.btnIcon]}
    />
  );
}
